import { render } from "./CalcExpectedPrice.vue?vue&type=template&id=667c60c0&scoped=true&ts=true"
import script from "./CalcExpectedPrice.vue?vue&type=script&lang=ts"
export * from "./CalcExpectedPrice.vue?vue&type=script&lang=ts"

import "./CalcExpectedPrice.vue?vue&type=style&index=0&id=667c60c0&scoped=true&lang=css"

import exportComponent from "/home/runner/work/angelleague-front/angelleague-front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-667c60c0"]])

export default __exports__